// components
import { Paths } from 'src/config';
import SvgIconStyle from '../../../components/SvgIconStyle';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  user: getIcon('ic_user'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  variables: <LibraryBooksIcon />,
};

const sidebarConfig = [
  {
    items: [{ title: 'خانه', path: '#', icon: ICONS.dashboard }],
  },
  {
    items: [
      {
        title: 'دوره ها',
        path: '/course/list',
        icon: ICONS.user,
        children: [
          { title: 'همه دوره ها', path: '/course/list' },
          { title: 'ثبت دوره جدید', path: '/course/create' },
          { title: 'مشارکت کننده دوره ها', path: '/course/participant' },
          { title: 'لیست برترین ها', path: '/course/leader-board' },
        ],
      },
    ],
  },
  {
    items: [
      {
        title: 'متغیر ها',
        path: Paths.courseLevels.list.path,
        icon: ICONS.variables,
        children: [
          { title: Paths.courseLevels.list.title, path: Paths.courseLevels.list.path },
          { title: Paths.category.list.title, path: Paths.category.list.path },
          { title: Paths.contentType.list.title, path: Paths.contentType.list.path },
          { title: Paths.tag.list.title, path: Paths.tag.list.path },
          { title: Paths.trainer.list.title, path: Paths.trainer.list.path },
        ],
      },
    ],
  },
  {
    items: [
      {
        title: 'تنظیمات لندینگ',
        path: Paths.courseLevels.list.path,
        icon: ICONS.variables,
        children: [
          { title: Paths.faq.list.title, path: Paths.faq.list.path },
          { title: Paths.story.list.title, path: Paths.story.list.path },
          { title: Paths.slider.list.title, path: Paths.slider.list.path },
        ],
      },
    ],
  },
  {
    items: [
      {
        title: Paths.package.list.title,
        path: Paths.package.list.path,
        // children: [
        //   { title: Paths.package.list.title, path: Paths.package.list.path },
        //   { title: Paths.package.create.title, path: Paths.package.create.path },
        // ],
      },
    ],
  },
  // {
  //   items: [
  //     {
  //       title: 'کلاس',
  //       // path: '/course/list',
  //       path: '#',
  //       icon: ICONS.user,
  //     },
  //   ],
  // },
];

export default sidebarConfig;
